import { StyledMotion, StyledTradeButton } from './styled'
import IconLock from '~/assets/images/lock-white.svg'
import { ReactComponent as IconLoading } from '~/assets/images/ellipse.svg'

export interface ITradeButton {
  onClick?: () => void
  disabled?: boolean
  needApprove?: boolean
  loading?: boolean
  ghost?: boolean
}

export const TradeButton: React.FC<ITradeButton> = ({
  onClick,
  disabled,
  children,
  needApprove,
  ghost,
  loading,
}) => {
  return (
    <StyledTradeButton
      onClick={disabled || loading ? null : onClick}
      ghost={ghost}
      disabled={disabled}
    >
      {children}
      {needApprove && <img className="approve-lock" src={IconLock} />}
      {loading && (
        <StyledMotion
          animate={{ rotate: [0, 360] }}
          transition={{
            duration: 1,
            ease: 'linear',
            origin: 'center',
            repeat: Infinity,
          }}
        >
          <IconLoading fill="#fff" />
        </StyledMotion>
      )}
    </StyledTradeButton>
  )
}
